module.exports = __webpack_public_path__ + "img/gear.41efb1a0.svg";